/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_P_Chat_DInputs */

const en_mk_nav_p_chat_d = /** @type {(inputs: Mk_Nav_P_Chat_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A channel per division, threads and direct messages.`)
};

const id_mk_nav_p_chat_d = /** @type {(inputs: Mk_Nav_P_Chat_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel per divisi, thread, dan pesan langsung.`)
};

/**
* | output |
* | --- |
* | "A channel per division, threads and direct messages." |
*
* @param {Mk_Nav_P_Chat_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_p_chat_d = /** @type {((inputs?: Mk_Nav_P_Chat_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_P_Chat_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_p_chat_d(inputs)
	return en_mk_nav_p_chat_d(inputs)
});